module.exports = __webpack_public_path__ + "1a09041e74965f7ca25951692f34384d.png";